// import request from "@/services/request";

export default {
  namespaced: true,
  state: {
    keycloak: null,
    fakeUser: null,
    canEdit: true,
    loading: false
  },
  mutations: {
    ['SET_AUTH_DATA'](state, payload) {
      state.keycloak = payload;
    },
    ['INIT_FAKE_USER'](state, data) {
      state.fakeUser = data;
    },
    ['LOADING'](state, payload) {
      state.loading = payload;
    },
  },
  actions: {
    setAuthData({commit, dispatch}, payload) {
      commit('SET_AUTH_DATA', payload);
      dispatch('spr/downloadSprData', null, {root: true});
      dispatch('checkFilled/loadingBlockInfo', null, {root: true});
      dispatch('checkFilled/loadingAllowBlockInfo', null, {root: true});
      dispatch('checkFilled/getContact', null, {root: true});
    },
    setAuthDataUpdate({commit, dispatch}, payload) {
      commit('SET_AUTH_DATA', payload);
      dispatch('checkFilled/loadingBlockInfo', null, {root: true});
      dispatch('checkFilled/loadingAllowBlockInfo', null, {root: true});
      dispatch('checkFilled/getContact', null, {root: true});
    },
    async logout({state}) {
      if (state.keycloak) {
        await localStorage.removeItem('vuex');
        state.keycloak.logout();
      }
    },
    async initFakeUser({commit}, payload) {
      commit('INIT_FAKE_USER', payload)
    },
    async clearFakeUser({commit}) {
      commit('INIT_FAKE_USER', null)
    },
  },
  getters: {
    getAuthData(state) {
      return state.keycloak
    },
    getRoles(state) {
      return state.keycloak?.realmAccess?.roles.filter(el => el !== 'default-roles-ppk_sso') ?? []
    },
    getFakeUser(state) {
      return state.fakeUser
    },
    getIdUser(_, getters){
      return getters.getUser?.orgID ?? getters.getFakeUser?.id
    },
    isAdmin(state) {
      return !!state.keycloak?.realmAccess?.roles.find(el => el === 'ADMIN_ROLE')
    },
    isAdminGroup(state) {
      return !!state.keycloak?.realmAccess?.roles.find(el => el === 'ADMIN_ROLE' || el === 'REGION_ADMIN_ROLE')
    },
    isDisabledEnter(state) {
      return !state.canEdit
    },
    checkLoadingStatus(state) {
      return state.loading
    },
    getUser(state) {
      return state.keycloak?.tokenParsed
    },
    getUserRoles(state) {
      return state.keycloak?.tokenParsed?.realm_access?.roles
    },
    getUserAccessToken(state) {
      return state.keycloak.token
    },
    getKeycloakData(state) {
      return state.keycloak
    },
  }
}